import Vue from 'vue'
import orderManageApi from '@/api/orderManage/api.order'

const 	SETORDERLIST 	= 'SETORDERLIST',
		SIGNORDER 		= 'SIGNORDER',
		ORDERCANCEL  	= 'ORDERCANCEL';


// import '../../Mock/orderManageMock'

export default {
	state: {
		orderList: [],
		pageSize: 10,
		page: 1
	},
	actions: {
		getOrderList({commit,state}, {merchantStatus}){
			const { page, pageSize } = state;
			let params = {
				pageSize,merchantStatus,
				pageNo: page,
			}
			console.log('getOrderList',params)
			return new Promise(function(resolve, reject){
             	orderManageApi.getOrderList(params,function(res){
					var res = res.body;
					if(res.meta.code == '00000'){
						commit('SETORDERLIST',res.data)
						resolve();
					}
				})
			})
		},
		checkReceive({commit},{orderCode,itemIndex,index}){
			return new Promise(function(resolve,reject){
				orderManageApi.signOrder(orderCode,function(res){
					var res = res.body;
					if(res.meta.code == '00000'){
						commit('SIGNORDER',{itemIndex,index})
						resolve();
					}
				})

			})
		}
	},
	mutations:{
		SETORDERLIST(state, data){
			state.page = state.page+1;
			state.totalPage =  data.totalPage;
			state.orderList =  state.page <=1 ? data.itemList :  state.orderList.concat(data.itemList);	
		},
		resetOrderList(state,data){
			state.page = 1;
			state.totalPage =  0;
			state.orderList =  [];	
		},
		SIGNORDER(state, {itemIndex,index}){
			state.orderList[itemIndex].merchantOrderDetailVos[index].userOrderStatus = 9;
			state.orderList[itemIndex].merchantOrderDetailVos[index].userOrderStatusDesc = "用户已签收";
		},
		ORDERCANCEL(state,index){
			state.orderList[index].userOrderStatusDesc = '支付超时已取消';
        	state.orderList[index].cancel = 0 ;
        	state.orderList[index].userOrderStatus = 0;
        	state.orderList[index].merchantOrderDetailVos.map(function(item){
				item.userOrderStatusDesc = '支付超时已取消';
	        	item.cancel = 0;
	        	item.userOrderStatus = 12;
        	})
		}
	}
}


// WEBPACK FOOTER //
// ./src/js/store/orderManageState.js